import cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";

import dayjs from "dayjs";

const { VITE_AUTH_COOKIE_DOMAIN } = process.env;

export const CSRF_COOKIE_NAME = "x-csrf-token";
export const AUTH_COOKIE_NAME = "x-auth-token-field";
export const REFRESH_COOKIE_NAME = "oeta-field-refresh-token";

export const isAuthCookiePresent = () => Boolean(cookies.get(AUTH_COOKIE_NAME));

export const saveAuthCookie = (cookieValue: string) => {
  cookies.set(AUTH_COOKIE_NAME, `${cookieValue}`, {
    domain: VITE_AUTH_COOKIE_DOMAIN,
    secure: true,
    sameSite: "Lax",
    hostOnly: true,
    expires: 7,
  });
};

export const removeAuthCookie = () => cookies.remove(AUTH_COOKIE_NAME);
export const getAuthCookie = () => cookies.get(AUTH_COOKIE_NAME);
export const getCSRFToken = () => cookies.get(CSRF_COOKIE_NAME);

export const setRefreshToken = ({ token }: { token: string }) => {
  cookies.set(REFRESH_COOKIE_NAME, token, {
    domain: VITE_AUTH_COOKIE_DOMAIN,
    secure: true,
    sameSite: "Lax",
    expires: 30,
  });
}

export const getRefreshToken = () => cookies.get(REFRESH_COOKIE_NAME);
export const removeRefreshToken = () => cookies.remove(REFRESH_COOKIE_NAME);

export const isJwtExpired = (jwt: string) => {
  try {
    const { exp }: { exp: number } = jwtDecode(jwt);
    const expirationDate = dayjs(exp * 1000);
    const now = dayjs();
    return now.isAfter(expirationDate);
  } catch (error) {
    console.error(error);
    throw new Error("Error decoding JWT");
  }
};
